import { Grid, TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, Typography } from '@mui/material';

export default function RofBatchBulkDensity({ batchBulkDensity, selectedProject }) {
    return (
        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h5">Batch Bulk Density</Typography>
            <TableContainer key={0} component={Paper} sx={{ height: 'auto' }}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">
                                ProjectId
                            </TableCell>
                            <TableCell align="left">
                                BatchId
                            </TableCell>
                            <TableCell align="left">
                                KilnId
                            </TableCell>
                            <TableCell align="left">
                                Empty Bucket Mass
                            </TableCell>
                            <TableCell align="left">
                                Hot Char and Bucket Mass
                            </TableCell>
                            <TableCell align="left">
                                Bucket Volume
                            </TableCell>
                            <TableCell align="left">
                                Bulk Density
                            </TableCell>
                            <TableCell align="left">
                                Lower Bound Bulk Density
                            </TableCell>
                            <TableCell align="left">
                                Unit
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {batchBulkDensity?.data?.map((data, i) => {
                            const isLastIteration = i === batchBulkDensity.length - 1
                            return (
                                <TableRow key={i}>
                                    <TableCell align="left">
                                        {data.projectId}
                                    </TableCell>
                                    <TableCell align="left">
                                        {data.batchId}
                                    </TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>
                                        {data.kilnUsed}
                                    </TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>
                                        {data.emptyBucketMass}
                                    </TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>
                                        {data.hotCharAndBucketMass}
                                    </TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>
                                        {data.bucketVolume}
                                    </TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>
                                        {data.bulkDensity}
                                    </TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>
                                        {data.lowerBoundBulkDensity}
                                    </TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>
                                        {selectedProject?.measureType === 'Imperial' ? <> lbs/yrd<sup>3</sup></> : <> kg/m<sup>3</sup></>}
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                        <TableRow>
                            <TableCell align="left"></TableCell>
                            <TableCell align="left"></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}><b>AVERAGE</b></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}>{batchBulkDensity?.total?.totalAverageBulkDensity}</TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}>{selectedProject?.measureType === 'Imperial' ? <> lbs/yrd<sup>3</sup></> : <> kg/m<sup>3</sup></>}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    )
}
